"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { EventEmitter } from "events";
import { w3cwebsocket as WebSocketClient } from "websocket";
import API from "@ym-framework/api-utils";
import { VIEW_WEBSOCKET } from "@/configuration/websocketskey";
import _ from "lodash";
export class WebsocketViewService extends EventEmitter {
  constructor() {
    super();
  }
  static send(data) {
    return __async(this, null, function* () {
      const _send = yield API.post(`api://base.ws/websockets/${VIEW_WEBSOCKET}`, {
        data
      });
      return _send;
    });
  }
  static run() {
    return __async(this, null, function* () {
      if (this._ipcClient === null) {
        this._ipcClient = new Promise((resolve, reject) => __async(this, null, function* () {
          var _a, _b;
          const _extension = (_a = chrome == null ? void 0 : chrome.application) == null ? void 0 : _a.extension();
          let _ipc = _extension.ipc;
          try {
            const new_ipc = (_b = chrome == null ? void 0 : chrome.clientServer()) == null ? void 0 : _b.url;
            _ipc = _extension.ipc ? _extension.ipc : new_ipc;
          } catch (error) {
            _ipc = _extension.ipc;
          }
          const _ws = `${_ipc.replace("http", "ws")}/ws/${VIEW_WEBSOCKET}`;
          const _wsClient = new WebSocketClient(_ws);
          _wsClient.onerror = () => {
            this._ipcEvent.emit("error");
            this.reconnect();
          };
          _wsClient.onopen = () => {
            this._ipcEvent.emit("connect");
          };
          _wsClient.onclose = () => {
            this._ipcEvent.emit("close");
            this.reconnect();
          };
          _wsClient.onmessage = (event) => {
            const _message = JSON.parse(event.data.toString());
            const _model = _message.model;
            this._ipcEvent.emit(`event:${_model}`, _message);
          };
          resolve(_wsClient);
        }));
      }
      return this._ipcClient;
    });
  }
}
WebsocketViewService._ipcClient = null;
WebsocketViewService._ipcEvent = new EventEmitter();
WebsocketViewService.reconnect = _.debounce(function() {
  return __async(this, null, function* () {
    this._ipcClient = null;
    yield this.run();
  });
}, 800);
